<script>
  import { Button } from '@shared/ui/buttons/button';
  import { Icon } from '@shared/ui/icon';
</script>

<div class="flex h-full w-full flex-col items-center justify-center gap-12">
  <Icon name="success" width="{44}" height="{44}" />

  <p class="text-center text-4xl font-light">The report has been <br /> successfully saved.</p>

  <Button on:click class="w-52">Close</Button>
</div>
